module.exports = __webpack_public_path__ + "47c8bdfa30b9f9c20777cf2b7271720e.glb";